/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deleteAccountRequestSchema = z
	.object({
		otp_code: z.string().min(1),
	})
	.describe("Сериализатор удаления учётки.");
